/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".legendWideControlGroup{margin:0 0 20px}.legendWideControlGroup label{margin-top:4px;font-weight:700}.legendWideControlGroup fieldset{margin-bottom:0}.symbol-editor label{margin-bottom:8px}.color-swatch{display:inline-block;width:50px;height:30px}.color-swatch:hover{cursor:pointer}.cancel-button{margin:7px 7px 0 0}.cancel-button:hover{cursor:pointer}.color-picker .sketch-picker{width:200px}.canvas{display:inline-block;height:36px;margin-left:5px;vertical-align:top;width:77.5%}"];
export { styles as styles };
